import script from "./HomeFacilityComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeFacilityComponent.vue?vue&type=script&setup=true&lang=js"

import "./HomeFacilityComponent.vue?vue&type=style&index=0&id=55ac6f44&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55ac6f44"]])

export default __exports__